export default __webpack_public_path__ + "static/media/pack4.a141a3bc.svg";